<template>
    <v-text-field
      v-bind="$attrs"
      :value="formatedValue"
      @input="updatedValue($event)"
      v-mask="mask"
      filled
    ></v-text-field>
</template>

<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  const currencyMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    includeThousandsSeparator: true,
    allowNegative: true,
    decimalSymbol: ',',
    thousandsSeparatorSymbol: '.',
  })
  export default {
    name: 'CurrencyField',
    props: {
      value: {},
    },
    data: () => ({
      mask: currencyMask,
    }),
    computed: {
      formatedValue () {
        if (!this.value) {
          return this.value
        }
        const readyValue = parseFloat(this.value).toFixed(2).replace(/\./ig, ',')
        return readyValue
      },
    },
    methods: {
      updatedValue (value) {
        const readyValue = value.replace(/\./ig, '').replace(',', '.')
        this.$emit('input', readyValue)
      },
    },
  }
</script>

<style scoped>

</style>
